import * as React from 'react'
import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { ChevronDownIcon } from '@radix-ui/react-icons'

import { cn } from 'src/libs/utils'

const Accordion = AccordionPrimitive.Root

const AccordionItem = React.forwardRef(({ className, ...props }, ref) => <AccordionPrimitive.Item ref={ref} className={cn('yborder-b', className)} {...props} />)
AccordionItem.displayName = 'AccordionItem'

const AccordionTrigger = React.forwardRef(({ className, children, icon = true, ...props }, ref) => (
	<AccordionPrimitive.Header className='yflex'>
		<AccordionPrimitive.Trigger ref={ref} className={cn('yflex yflex-1 yitems-center yjustify-between ypy-4 ytext-sm yfont-medium ytransition-all hover:yunderline [&[data-state=open]>svg]:yrotate-180', className)} {...props}>
			{children}
			{icon && <ChevronDownIcon className='yh-4 yw-4 yshrink-0 ytext-muted-foreground ytransition-transform yduration-200' />}
		</AccordionPrimitive.Trigger>
	</AccordionPrimitive.Header>
))
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
	<AccordionPrimitive.Content ref={ref} className='yoverflow-hidden ytext-sm data-[state=closed]:yanimate-accordion-up data-[state=open]:yanimate-accordion-down' {...props}>
		<div className={cn('ypb-4 ypt-0', className)}>{children}</div>
	</AccordionPrimitive.Content>
))
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }

